module.exports = __webpack_public_path__ + "36f0e13bce11ade67cc4bdc44d8d4bc3.svg";